<template>
  <div class="upgrade">
      <span class="h2 fw-light">
        <img src="/static/img/logo_dark_new.png" width="100" alt="logo" class="mb-4">
        <p class="h2 strong text-poppins">{{ title }}</p>
        <p class="h4 text-poppins">{{ text }}</p>
        <div class="mt-4">
          <router-link to="/upgrade?from=analytics" tag="button" class="btn btn-primary">{{ $t('upgrade_now') }}</router-link>
        </div>
      </span>
  </div>
</template>
<script>
export default {
  name: 'UpgradeOverlay',
  props: ['title', 'text'],
  data: function () {
    return {}
  }
}
</script>
<style lang="scss">
.upgrade {
  text-align: center;
  padding: 5%;
  z-index: 5;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  color: black;
  background: rgba(255, 255, 255, 0.95);
}
</style>



// WEBPACK FOOTER //
// src/components/UpgradeOverlay.vue